import { createTheme, ThemeProvider } from '@mui/material'
import { Provider } from "react-redux";
import AppRoot from "./pages/AppRoot/AppRoot";
import { store, saveCurrentState } from "./store";


const appTheme = createTheme({
  typography:  {
    fontFamily: [
      'var(--font-family)',
    ].join()
  },
});

function App() {
  store.subscribe(()=> { saveCurrentState(store.getState()) })

  return (
    <Provider store={store}>
      <ThemeProvider theme={appTheme}>
          <AppRoot />
      </ThemeProvider>
    </Provider>
  );
}

export default App;